module.exports = __webpack_public_path__ + "static/media/image_Richard_Bell-Davies.b6382bb5.png";